import { COMPANY, LAST_UPDATED } from './legalConstants';

// Shared shell so every legal page has consistent typography +
// company identity at the top. Keeps each page's source small and
// focused on the legal copy. TODO i18n — Dutch-only for this slice.
export default function LegalPage({ title, testId, children }) {
  return (
    <article
      data-testid={testId}
      className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-20"
    >
      <header className="mb-10">
        <h1 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-2">
          {title}
        </h1>
        <div className="w-10 h-px bg-accent" />
        <div
          data-testid="legal-company-identity"
          className="text-xs text-muted-foreground mt-4 leading-relaxed space-y-0.5"
        >
          <div>{COMPANY.legalName}</div>
          <div>
            {COMPANY.address.street} ·{' '}
            {COMPANY.address.postalCode} {COMPANY.address.city} ·{' '}
            {COMPANY.address.country}
          </div>
          <div>
            BTW {COMPANY.vatNumber} · {COMPANY.rpr}
          </div>
          <div>
            <a className="underline" href={`mailto:${COMPANY.email}`}>
              {COMPANY.email}
            </a>
            {' · '}Niet telefonisch bereikbaar
          </div>
        </div>
        <p className="text-[10px] text-muted-foreground/70 mt-3">
          Laatst bijgewerkt: {LAST_UPDATED}
        </p>
      </header>
      <div className="prose prose-sm max-w-none text-foreground space-y-6 leading-relaxed">
        {children}
      </div>
      <p className="mt-12 text-[10px] text-muted-foreground/70">
        TODO juridische review · TODO i18n (FR/EN).
      </p>
    </article>
  );
}
